import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["WAREHOUSE_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["WAREHOUSE_MODULE"],
  },
];

export default routes;
